import { RentCompInfoType } from "./../features/Comp/interfaces";
import { apiClient } from "lib/apiClient";
import { ICreateRentComp } from "pages/Comps/components/RentCompModal/interfaces";
import { IResearchCompContext } from "features/Research/types";

export interface IEditRentComp extends ICreateRentComp {
  id: string;
}

export const editRentComp = async (
  request: IEditRentComp | RentCompInfoType,
  researchContext?: IResearchCompContext
): Promise<RentCompInfoType> => {
  const response = await apiClient.put(`/comps/rent`, request, {
    params: {
      workItemId: researchContext?.workItemId,
      workItemVersion: researchContext?.version,
    },
  });

  return response.data;
};
